<template>
  <div class="tiaoartic">
    <div class="artichea between">
      <div class="ticheatle">{{ colitem.cat_name }}</div>
      <div class="flex_end">
        <!-- <div class="ifylist">
          <span
            class="ifyitem"
            v-for="(item, index) in colitem.children"
            :key="index"
            @click="tojump(item)"
            >{{ item.cat_name }}</span
          >
        </div> -->
        <div class="ifymo">更多</div>
      </div>
    </div>
    <div class="articcont between">
      <div class="leftlist">
        <div
          class="lflitem flex_start"
          v-for="(item, index) in leftlist"
          :key="index"
          :class="{ lflitemactive: active == index }"
          @mouseover="active = index"
            @click="tojumpdet(item)"
        >
          <div class="sortnum" :class="{ sortnum1: index < 3 }">
            {{ index + 1 }}
          </div>
          <div class="txt">
            <div class="tit ellipsis">{{ item.title  }}</div>
            <div class="des">
              {{ item.content | toEllipsisFilter(32) }}
            </div>
          </div>
        </div>
      </div>
      <div class="cent">
        <div class="ceto flex_start" 
            @click="tojumpdet(cen1)">
          <div class="cove">
            <img src="../../../assets/jpcol/artic1_sample.png" alt="" />
          </div>
          <div class="info" v-if="cen1">
            <div class="tit ellipsis">{{ cen1.title}}</div>
            <div class="dec">
              {{ cen1.content | toEllipsisFilter(90) }}
            </div>
          </div>
        </div>
        <div class="cebtm">
          <div
            class="cebtmitem"
            v-for="(item, index) in cen1list"
            :key="index"
            @click="tojumpdet(item)"
          >
            {{ item.title  }}
          </div>
        </div>
      </div>
      <recomlayadv class="right"></recomlayadv>
    </div>
  </div>
</template>

<script>
import recomlayadv from "../components/recomlayadv";
export default {
  props: ["colitem"],
  components: {
    recomlayadv,
  },
  data: () => ({
    active: 0,
    current: {},
    leftlist: [],
    cen1list: [],
    cen1: {},
  }),
  beforeMount() {
    this.current = this.colitem;
    this.current.children = this.current.children.slice(0, 9);
    this.getartleft();
    this.getartcen();
  },
  methods: {
    tojump(item) {
      this.$router.push({
        path: "/jpcol/tiaoli/tiaoliifyul",
        query: {
          id: item.id,
        },
      });
    },
    tojumpdet(item) {
      this.$router.push({
        path: "/jpcol/tiaoli/tiaolidetail",
        query: {
          tlId: item.id,
        },
      });
    },
    getartleft() {
      let data = {
        page: 1,
        cat_id: this.current.id,
        limit: 12,
        order: "hot",
      };
      this.$http.jpcol.gettiaolilist(data).then((res) => {
        this.leftlist = res.data.data;
      });
    },
    getartcen() {
      let data = {
        page: 1,
        cat_id: this.current.id,
        limit: 10,
        order: "new",
      };
      this.$http.jpcol.gettiaolilist(data).then((res) => {
        this.cen1 = res.data.data[0];
        this.cen1list = res.data.data.slice(1, 10);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tiaoartic {
  width: 1200px;
  margin: 0 auto;
  padding: 30px 0;
  .artichea {
    padding-bottom: 15px;
    border-bottom: 1px solid #eee;
    .ticheatle {
      font-size: 30px;
      color: #333333;
    }
    .ifylist {
      .ifyitem {
        cursor: pointer;
        font-size: 14px;
        color: #333333;
        margin-left: 30px;
      }
    }
    .ifymo {
      cursor: pointer;
      margin-left: 40px;
      font-size: 16px;
      color: #999999;
    }
  }
  .articcont {
    margin-top: 30px;
    align-items: flex-start;
    .leftlist {
      width: 260px;
      .lflitem {
        cursor: pointer;
        align-items: flex-start;
        font-size: 14px;
        margin-bottom: 24px;
        .sortnum {
          width: 20px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          background: #b2b2b2;
          border-radius: 50%;
          color: #ffffff;
          margin-right: 8px;
        }
        .sortnum1 {
          background: #ff8a22;
        }

        .txt {
          width: 85%;
          .tit {
            color: #333333;
          }
          .des {
            display: none;
            margin-top: 8px;
            font-size: 12px;
            color: #bbbbbb;
          }
        }
        &:hover {
          .txt .tit {
            color: #0465ea;
          }
        }
        &.lflitemactive {
          .txt .des {
            display: block;
          }
        }
      }
    }
    .cent {
      width: 620px;
      .ceto {
        align-items: flex-start;
        .cove {
          margin-right: 22px;
          img {
            width: 210px;
            height: 150px;
            border-radius: 5px;
          }
        }
        .info {
          padding-top: 8px;
          width: 60%;
          cursor: pointer;
          .tit {
            font-size: 20px;
            color: #333333;
          }
          .dec {
            line-height: 22px;
            margin-top: 10px;
            font-size: 14px;
            color: #999999;
          }
        }
      }
      .cebtm {
        margin-top: 36px;
        font-size: 18px;
        .cebtmitem {
          line-height: 18px;
          margin-top: 24px;
          padding-left: 25px;
          color: #333333;
          cursor: pointer;
          position: relative;

          &:hover {
            color: #0465ea;
          }
          &::before {
            content: "";
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 0;
            width: 8px;
            height: 8px;
            background: #dddddd;
            border-radius: 50%;
          }
        }
      }
    }
    .right {
      width: 270px;
      box-shadow: 0px 2px 15px 0px rgba(1, 1, 1, 0.1);
      height: 540px;
    }
  }
}
</style>